import PropTypes from 'prop-types'
import React from 'react'

export default function Row({ children }) {
  return <ul className="list ma0 pv4 ph0 w-100">{children}</ul>
}

Row.propTypes = {
  children: PropTypes.node,
}
